import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Megaphone, Target, TrendingUp, Users } from "lucide-react";
import headerBgMobile from '@/assets/header-bg-mobile.jpg';

export default function Advertise() {
  return (
    <div className="min-h-screen relative">
      {/* Fixed Background Image */}
      <div 
        className="fixed inset-0 bg-cover bg-center bg-no-repeat z-0"
        style={{
          backgroundImage: `url(${headerBgMobile})`
        }}
      />
      
      {/* Content with backdrop */}
      <div className="relative z-10 w-full mx-auto max-w-6xl bg-white/5 backdrop-blur-sm shadow-xl pb-8">
        <div className="container mx-auto px-4 py-8 max-w-6xl">
      <div className="mb-8">
        <h1 className="text-4xl font-bold mb-2 text-white">Advertise on YieldSocial</h1>
        <p className="text-white text-lg">
          Reach farmers and agricultural professionals where they connect and collaborate
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3 mb-8">
        <Card>
          <CardHeader>
            <Target className="h-8 w-8 mb-2 text-primary" />
            <CardTitle>Targeted Reach</CardTitle>
            <CardDescription>
              Connect with verified farmers and agricultural businesses in specific regions
            </CardDescription>
          </CardHeader>
        </Card>

        <Card>
          <CardHeader>
            <Users className="h-8 w-8 mb-2 text-primary" />
            <CardTitle>Engaged Community</CardTitle>
            <CardDescription>
              Access an active community of farmers sharing knowledge and resources
            </CardDescription>
          </CardHeader>
        </Card>

        <Card>
          <CardHeader>
            <TrendingUp className="h-8 w-8 mb-2 text-primary" />
            <CardTitle>Measurable Results</CardTitle>
            <CardDescription>
              Track your campaign performance with detailed analytics and insights
            </CardDescription>
          </CardHeader>
        </Card>
      </div>

      <Card className="mb-8">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Megaphone className="h-6 w-6" />
            Advertising Opportunities
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <div>
            <h3 className="text-lg font-semibold mb-2">Sponsored Posts</h3>
            <p className="text-muted-foreground mb-2">
              Promote your products or services directly in the community feed
            </p>
            <ul className="list-disc list-inside text-sm text-muted-foreground space-y-1 ml-4">
              <li>Targeted by location and interests</li>
              <li>Flexible duration and budget</li>
              <li>Performance metrics included</li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-2">Banner Advertising</h3>
            <p className="text-muted-foreground mb-2">
              Premium placement in high-visibility areas
            </p>
            <ul className="list-disc list-inside text-sm text-muted-foreground space-y-1 ml-4">
              <li>Homepage and category pages</li>
              <li>Desktop and mobile optimized</li>
              <li>Monthly or quarterly packages</li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-2">Event Sponsorship</h3>
            <p className="text-muted-foreground mb-2">
              Support agricultural events and get featured exposure
            </p>
            <ul className="list-disc list-inside text-sm text-muted-foreground space-y-1 ml-4">
              <li>Logo placement and mentions</li>
              <li>Dedicated announcements</li>
              <li>Community goodwill</li>
            </ul>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Get Started</CardTitle>
          <CardDescription>
            Ready to connect with our farming community?
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">
            Contact our advertising team to discuss your needs and create a custom campaign that works for your business.
          </p>
          <div className="flex flex-wrap gap-4">
            <Button size="lg">
              Request Media Kit
            </Button>
            <Button size="lg" variant="outline">
              Contact Sales
            </Button>
          </div>
          <p className="text-xs text-muted-foreground">
            Email: <a href="mailto:advertise@yieldsocial.com" className="underline">advertise@yieldsocial.com</a>
          </p>
        </CardContent>
      </Card>
        </div>
      </div>
    </div>
  );
}
